<app-dialog-base [Title]='"Retranslations"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">

  <div class="btn_tabs">
    <button (click)="openTab('main')" [class.active]="openedTabName == 'main'">{{"Main"|translate}}</button>
    <button (click)="openTab('objects')" [class.active]="openedTabName == 'objects'">{{"Objects"|translate}}</button>
  </div>

  <div class="horseparator"></div>

  <div class="tablewrap">
    <div id="main" *ngIf="isSelected('main')">
      <div class="inputgroup">
        <label>{{'Name'|translate }}</label>
        <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="model.Name" />
      </div>
      <div class="inputgroup">
        <label>{{'Retranslation protocol'|translate }}</label>
        <select (change)="onProtocolChange($event)">
          <option *ngFor="let protocol of protocols"
                  [selected]="model.Protocol == protocol.value"
                  [value]="protocol.value">
            {{protocol.text}}
          </option>
        </select>
      </div>
      <div class="inputgroup">
        <label>{{'Status'|translate }}</label>
        <select (change)="onStatusChange($event)">
          <option *ngFor="let status of statuses"
                  [selected]="model.Status == status.value"
                  [value]="status.value">
            {{status.text}}
          </option>
        </select>
      </div>
      <div class="inputgroup">
        <label>{{'Server'|translate }}</label>
        <input type="text" placeholder="{{'Server'|translate }}" [(ngModel)]="model.ServerAddress" />
      </div>
      <div class="inputgroup">
        <label>{{'Port'|translate }}</label>
        <input type="text" placeholder="{{'Port'|translate }}" [(ngModel)]="model.ServerPort" />
      </div>
      <div class="inputgroup">
        <label>{{'Retranslation from'|translate}}</label>
        <calendar [name]="'From'" [(date)]="model.From" [clear]="true"></calendar>
      </div>
      <div class="inputgroup">
        <label>{{'Retranslation till'|translate}}</label>
        <calendar [name]="'Till'" [(date)]="model.Till" [clear]="true"></calendar>
      </div>
    </div>

    <div id="objects" *ngIf="isSelected('objects')">
      <app-object-mgmnt [model]="model"/>
    </div>
  </div>

</app-dialog-base>
